import React, {Fragment, useEffect, useState} from 'react'
import {Button, Form, Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useFormik} from 'formik'
import {LoadingComponent} from 'recupero-comunes'
import Acciones from './acciones'
import {validationSchemas} from '../../../../common/validation-Schemas-tipo-gasto'
import {limpiarRefAction, obtenerGrillaHistorialGastos, postActualizarTipoGastoJudicial} from '../../../../store/actions/proceso-judicial-action'
import GastosHonorarios from './gastosHonorarios'
// import Historial from './historial'
const GastosHonorariosModal = ({showGastos, handleCloseGastos}) => {
    const [loading, setLoading]=useState(false)
    const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
    const {llaves} = data_recepciona
    
    const [isGastoHonorario, setIsGastoHonorario] = useState(false)
    const [isAudiencia, setIsAudiencia] = useState(false)
    const data_judicial = useSelector((state) => state.procesoJudicialReducer)
    const {comboTipoGasto} = data_judicial
    const [miMontoNoFormato, setMiMontoNOFormato] = useState('')
    const [showToastAnular, setShowToastAnular] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [isLimpiar, setIsLimpiar] = useState(false);
    const [listaGrilla, setListaGrilla] = useState(null)
    const dispatch = useDispatch()
    const handleCloseToastAnular = () => setShowToastAnular(false)
    const handleShowToastAnular = () => setShowToastAnular(true) 
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true) 
    
    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "tipoGasto": "",
            "cobertura": "",
            "moneda": "",
            "monto": "",
            "fechaOcurrencia": "",
            "comentario": ".",
            "secuencia": "",
            "idUsuario": ""
        },
        validationSchema: validationSchemas(isGastoHonorario),
        onSubmit: (formData) => {
            const dataForm = {
                ...formData
            }
            dataForm['idCaso'] = llaves && llaves['idCaso']
            dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado']
            dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso']
            dataForm['idUsuario'] = llaves && llaves['idUsuario']
            dataForm['monto'] = miMontoNoFormato
            const secuencia = 0
            dataForm['secuencia'] = secuencia

            let cob = comboTipoGasto && comboTipoGasto.comboTipoGasto.find(c => c.id === parseInt(dataForm['tipoGasto'])).agrupacion
            dataForm['cobertura'] = cob
            
            setLoading(true)
            if(formData.file){
                getBase64(formData.file).then((base64data) => { 
                    const fileData=base64data.split(',')[1]
                let data = { ...dataForm, "filename": formData.file.name, "mimetype": formData.file.type, "base64data": fileData };
                dispatch(postActualizarTipoGastoJudicial(data)).then(()=>historial())
                .then(()=>{
                    dispatch(limpiarRefAction(true))
                    handleShowToast()
                    setIsLimpiar(true)
                    formik.touched.file=false
                  })
                  .then(()=>{
                    delete formData['file']
                  })
                .then(()=>{setLoading(false)})
                })
            }else{
                dispatch(postActualizarTipoGastoJudicial(dataForm)).then(()=>historial()).then(()=>{setLoading(false)})
                handleShowToast()
                setIsLimpiar(true)
            }
            // setListaGrilla([...listaGrilla,listaGrilla.concat(dataForm)])
           
        }
    })
    const historial=()=>{
        let query = Buffer.from(
            JSON.stringify({"idCaso": llaves && llaves["idCaso"],
            "idImplicado": llaves && llaves["idImplicado"],
           })
          ).toString('base64')
          dispatch(obtenerGrillaHistorialGastos(query))
    }
    return (
        <>
        <LoadingComponent show={loading}/>
            <Modal show={showGastos}
                onHide={handleCloseGastos}
                size='xl'>
                <Form onSubmit={
                    formik.handleSubmit
                }>
                    <GastosHonorarios formik={formik}                        
                        isLimpiar={isLimpiar}
                        setIsLimpiar={setIsLimpiar}
                        setMiMontoNOFormato={setMiMontoNOFormato}
                        showToastAnular={showToastAnular}
                        setShowToastAnular={setShowToastAnular}
                        showToast={showToast}
                        setShowToast={setShowToast}      
                        setIsGastoHonorario={setIsGastoHonorario}              
                        />
                    <Acciones 
                        handleShowToastAnular={handleShowToastAnular}
                        setIsLimpiar={setIsLimpiar}
                        handleCloseGastos={handleCloseGastos}
                        setListaGrilla={setListaGrilla}
                        listaGrilla={listaGrilla}
                    />
                </Form>
            </Modal>
        </>
    )
}

export default GastosHonorariosModal
const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
    });
  };